import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { NotificationSettingsModel } from '../models/notification_settings_model';
export class NotificationSettingsDetailsController {
  categories: any;
  contactInfoConfig: any;
  formSubmitCallback: () => void;
  isDesktop: boolean;
  constructor(
    private $state: ng.ui.IStateService,
    private notificationSettingsModel: NotificationSettingsModel,
    private updateAllNotificationSettingsCommand: ICommand
  ) {}

  $onInit(): void {
    this.categories = _4.sortBy(this.notificationSettingsModel.getAllCategories(), 'rank');
    this.contactInfoConfig = undefined;
    this.formSubmitCallback = () => {
      this.updateAllCommand();
    };
    this.isDesktop = PlatformUtility.isDesktop();
  }

  goToEditContactInformation(): void {
    this.$state.go('my.contactInformation');
  }

  isDesktopCategoryPrevented(category: any) {
    //Push notifications are not shown at all for desktop, so if that's the only thing allowed (like for appointment notifications)
    //then don't show the category at all for desktop
    return this.isDesktop && this.onlyPushNotificationsAllowed(category);
  }

  onlyPushNotificationsAllowed(category: any): boolean {
    return category.email_send === 'PREVENT' && category.sms_send === 'PREVENT' && category.push_send !== 'PREVENT';
  }

  updateAllCommand() {
    this.updateAllNotificationSettingsCommand();
  }
}
export class NotificationSettingsDetailsComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-notification-settings/src/components/notification_settings_details.html';
  public controller: any = NotificationSettingsDetailsController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/components/notification_settings_details_controller.ts